export default __webpack_public_path__ + "static/media/beaver-step-2.754b053f.svg";